export default __webpack_public_path__ + "header-image-480-6a45488d27c70e4fd9825556c85b8e3c.webp";